import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { iStaffBaseURL } from "../../constants/Urls";
import { notify } from "../../functions/function";
import { readableStartEnd } from "../../functions/timeFormat";

import EnhancedTableHead from "./EnhancedTableHead";
import EnhancedTableToolbar from "./EnhancedTableToolbar";
import { toolTipContactDetails } from "../../functions/tooltips";
import IconButton from "@material-ui/core/IconButton";
import { dispatchUndonePlacements } from "./helperFunctions";
import { CBadge } from "@coreui/react";

const HistoryTable = ({
  placements,
  useStyles,
  userToken,
  checkboxes,
  dispatch,
  incompletePlacements,
}) => {
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  /* Start datetime | Client company name | location | employee | notify | save  */
  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Clocked Times",
    },
    {
      id: "startTime",
      numeric: true,
      disablePadding: false,
      label: "Client",
    },
    { id: "endTime", numeric: true, disablePadding: false, label: "Location" },
    {
      id: "clockInTime",
      numeric: true,
      disablePadding: false,
      label: "Employee",
    },
    {
      id: "status",
      numeric: true,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "undo",
      numeric: true,
      disablePadding: false,
      label: "Undo Approval",
    },
  ];

  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = placements.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    if (typeof event.target.className === "string") {
      if (event.target.className.includes("noPress")) {
        return;
      }
    }

    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, placements.length - page * rowsPerPage);

  const undoSelected = (selectedArr) => {
    /* Selected are the selected checkboxes. */
    let undoArray = [];
    for (let i in selectedArr) {
      let currentPlacement = placements.find((p) => p.id === selectedArr[i]);

      if (currentPlacement.timesheet) {
        undoArray.push({
          id: currentPlacement.timesheet.id,
          approval_status: "Pending",
          client_approval_status: "Pending",
        });
      }
    }

    axios
      .patch(iStaffBaseURL + "/handler/placements/timesheets/", undoArray, {
        headers: { Authorization: "Token " + userToken },
      })
      .then((res) => {
        dispatchUndonePlacements(dispatch, placements, selectedArr, undoArray);
        notify(
          "Success",
          "The selected timesheets have been moved back to the 'Timesheets' page.",
          "success"
        );
        setSelected([]);
      })
      .catch((err) => {
        notify(
          "Error",
          err.response.data.toString() +
            ". There was an error. Please try again",
          "danger"
        );
      });
  };

  return (
    <>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          title={"Completed Placements"}
          undoSelected={undoSelected}
          selected={selected}
          setSelcted={setSelected}
        />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={"medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={placements.length}
              headCells={headCells}
              checkboxes={checkboxes}
            />
            <TableBody>
              {stableSort(placements, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color={"default"}
                          checked={isItemSelected}
                          inputProps={{ "aria-labelledby": labelId }}
                          onClick={(event) => handleClick(event, row.id)}
                        />
                      </TableCell>

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                        align="center"
                      >
                        {readableStartEnd(
                          row.timesheet.clock_in_time,
                          row.timesheet.clock_out_time
                        )}
                      </TableCell>

                      <TableCell align="center">
                        {row.client.company_name}
                      </TableCell>

                      <TableCell align="center">{row.location}</TableCell>

                      <Tooltip
                        title={toolTipContactDetails(row.employee.user)}
                        className="noPress"
                      >
                        <TableCell align="center" className="">
                          {row.employee.user.first_name}{" "}
                          {row.employee.user.last_name}
                        </TableCell>
                      </Tooltip>

                      <TableCell align="center" className="">
                        <div className="row mb-2 justify-content-center">
                          {row.timesheet.approval_status === "Approved" ? (
                            <CBadge color="primary text-light">
                              iStaff Approved
                            </CBadge>
                          ) : (
                            <CBadge color="danger text-light">
                              iStaff Declined
                            </CBadge>
                          )}
                        </div>
                        <div className="row justify-content-center">
                          {row.timesheet.client_approval_status ===
                          "Approved" ? (
                            <CBadge color="primary text-light">
                              Client Approved
                            </CBadge>
                          ) : (
                            <CBadge color="danger text-light">
                              Client Declined
                            </CBadge>
                          )}
                        </div>
                      </TableCell>

                      <Tooltip title="Undo the selected timesheet.">
                        <TableCell align="center" className="text-warning">
                          <IconButton>
                            <button
                              type="button"
                              class="btn btn-warning justify-self-center"
                              style={{ color: "black" }}
                              onClick={() => {
                                undoSelected([row.id]);
                              }}
                            >
                              Undo
                            </button>
                          </IconButton>
                        </TableCell>
                      </Tooltip>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[placements.length, 25, 50, 100]}
          component="div"
          count={placements.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
};

export default connect()(HistoryTable);
